import React from "react";
import { Pagination, Button } from "zina-dogi-react";
import { Link } from "react-router-dom";
import { service as voaSummaryService } from "../redux";
import swal from "sweetalert";

const titles = ["Vendor", "Intrastate", "Interstate", "VOA Case", "Region", "Tax JD", "Category", "Cancelled"];

const VoaSummaryTable = ({ list, pagination, ...props }) => {
    const { className } = props;
    const voaTable_op = {
        className: ["voa_table", className].join(" ")
    };
    return (
        <div {...voaTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div className="voa_links controls">
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            voaSummaryService.requestSummaryReport().then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        Voa Vendor Summary Report
                    </Button>
                    <Link to="/voa/sumary/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        VOA Summary Importer
                    </Link>
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = list => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((summary, i) => {
            return (
                <tr key={`voa_${i}`} style={{ textAlign: "center" }}>
                    <td title={summary.vendor && `Vendor ID: ${summary.vendor.id}`}>
                        {summary.vendor && `${summary.vendor.vendor_number} - ${summary.vendor.legal_name}`}
                    </td>
                    <td>{summary.intrastate_voa && summary.intrastate_voa.voa_number}</td>
                    <td>{summary.interstate_voa && summary.interstate_voa.voa_number}</td>
                    <td>{summary.voa_case && summary.voa_case.name}</td>
                    <td>{summary.region}</td>
                    <td>{summary.tax_jd}</td>
                    <td>{summary.category}</td>
                    <td>{summary.cancelled ? "Yes" : "No"}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default VoaSummaryTable;
